import { render, staticRenderFns } from "./TheForgotPassword.vue?vue&type=template&id=b7010936&scoped=true"
import script from "./TheForgotPassword.vue?vue&type=script&lang=ts"
export * from "./TheForgotPassword.vue?vue&type=script&lang=ts"
import style0 from "./TheForgotPassword.vue?vue&type=style&index=0&id=b7010936&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7010936",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7010936')) {
      api.createRecord('b7010936', component.options)
    } else {
      api.reload('b7010936', component.options)
    }
    module.hot.accept("./TheForgotPassword.vue?vue&type=template&id=b7010936&scoped=true", function () {
      api.rerender('b7010936', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TheForgotPassword.vue"
export default component.exports